import React, { Component } from "react";
// import Select from "react-select";
import firebase from "../Firebase";
import FormStepNav from "./FormStepNav";

class Form3 extends Component {
  constructor() {
    super();
    this.ref = firebase.firestore().collection("employees");

    this.state = {
      // okb_jabatan: "",
      // okb_tanggal_masuk: "",
      // okb_departemen: "",
      // // ✅ State checkbox OKB (tambahkan semua)
      // okb_data_kartu_pokok_karyawan: false,
      // okb_form_bpjs_kesehatan: false,
      // okb_form_bpjs_ketenagakerjaan: false,
      // okb_formulir_aplikasi_bank_atau_copy_tabungan: false,
      // okb_surat_perjanjian_kerahasiaan: false,
      // okb_form_perlengkapan_kerja: false,
      // okb_surat_pernyataan_informasi_dasar_dan_keserdiaan: false,
      // okb_surat_perjanjian_kerja: false,
      // okb_buku_perjanjian_kerja_bersama: false,
      // okb_buku_peraturan_zona: false,
      // okb_perlengkapan_kerja: false,
      // okb_kartu_identitas_karyawan: false,
      // okb_office_tour: false,
      // okb_visi_misi_perusahaan: false,
      // okb_peraturan_penegakan_zona: false,
      // okb_perjanjian_kerja_bersama: false,
      // okb_sistem_manajemen_keamanan_pangan: false,
      // okb_smk3l: false,
      // okb_lain_lain_perlengkapan_okb: false,
      // okb_lain_lain_orientasi_perusahaan: false,
      // okb_bisnis_proses_departemen: false,
      // okb_deskripsi_pekerjaan: false,
      // okb_sop: false,
      // okb_work_instruction: false,
      // okb_sasaran_kinerja_3_bulan_karyawan_baru: false,
      // okb_penilaian_kinerja: false,
      // // ✅ State utilitas
      // isFormValid: false,
      // tanggal_masuk: this.currentDate(),
      // agreement: false,
      // submiting: false,
      // date: "",
      // time: "",
    };
  }

  componentDidMount() {
    this.cekLogin();
  }

  cekLogin = () => {
    const id = localStorage.getItem("id");
    if (id == null) {
      // Belum login, redirect ke halaman login
      this.props.history.push("/");
    } else {
      const lStorage = JSON.parse(id);

      // Cek apakah form 2 sudah diisi
      if (lStorage[0].form_2_submitted === "belum") {
        // Form 2 belum diisi, redirect ke form-2
        this.props.history.push("/form-2");
        return;
      }

      this.setState({
        nik: lStorage[0].nik,
        tanggal_lahir: lStorage[0].tanggal_lahir,
      });
    }
  };

  handleLogout = () => {
    localStorage.removeItem("id");
    this.props.history.push("/");
  };

  goToForm1 = (e) => {
    if (e) e.preventDefault();
    this.props.history.push("/form");
  };

  goToForm2 = (e) => {
    if (e) e.preventDefault();
    this.props.history.push("/form-2");
  };

  goToForm3 = (e) => {
    if (e) e.preventDefault();
    this.props.history.push("/form-3");
  };

  currentDate = () => {
    let date = new Date();
    return (
      date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
    );
  };

  render() {
    // ✅ Define custom styles as objects
    const listGroupItemStyle = {
      borderBottom: "1px solid #dee2e6",
      marginBottom: "0",
    };

    const borderPrimaryStyle = {
      borderColor: "#007bff",
      borderWidth: "2px",
      borderStyle: "solid",
    };

    const borderDangerStyle = {
      borderColor: "#dc3545",
      borderWidth: "2px",
      borderStyle: "solid",
    };

    const badgeStyle = {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      minHeight: "24px",
      lineHeight: "1",
    };

    return (
      <div className="">
        <nav className="main-header-navbar navbar-expand-lg navbar navbar-with-menu bg-white">
          <div className="container-fluid">
            <div className="navbar-wrapper" style={{ width: "100%" }}>
              <div className="navbar-container">
                <div className="navbar-collapse" id="navbar-mobile">
                  <div className="mr-auto float-left bookmark-wrapper d-flex align-items-center logo-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-row">
                        <li className="nav-item mr-auto">
                          <a className="navbar-brand" href="/">
                            <div className="brand-logo">
                              <img
                                alt="Logo"
                                className="logo"
                                src={require("../assets/logos/logo-pas.jpg")}
                              />
                            </div>
                          </a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="mr-auto bookmark-wrapper d-flex align-items-center header-container">
                    <div className="navbar-header">
                      <ul className="nav navbar-nav flex-column">
                        <li className="nav-item text-center">
                          <h1 className="font-header">
                            PT. PRAKARSA ALAM SEGAR
                          </h1>
                        </li>
                        <li className="nav-item text-center">
                          <h2 className="font-sub-header">
                            Human Resource Department
                          </h2>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div className="bookmark-wrapper d-flex align-items-center">
                    <FormStepNav
                      current="form_3"
                      onGoForm1={this.goToForm1}
                      onGoForm2={this.goToForm2}
                      onGoForm3={this.goToForm3}
                      showForm3
                    />
                    <button
                      className="btn btn-danger btn-sm"
                      onClick={this.handleLogout}
                      style={{ marginLeft: "10px" }}
                    >
                      <i className="bx bx-log-out"></i> Logout
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </nav>
        <div className="pembatas"></div>
        <section id="floating-label-layouts">
          <div className="container-fluid">
            <div className="row match-height">
              <div className="col-md-12 col-12">
                <div className="card bg-white">
                  <div className="card-header">
                    <h4 className="card-title text-center">
                      FORM DATA KARTU POKOK KARYAWAN
                    </h4>
                  </div>
                  <div className="card-content">
                    <div className="card-body">
                      {/* ✅ SECTION: Terima kasih */}
                      <div className="text-center mb-4">
                        <h2 className="text-primary">
                          🎉 Terima kasih telah mengisi form data karyawan
                        </h2>
                        <p className="lead">
                          Silahkan bergabung ke Google Classroom untuk
                          melanjutkan proses Orientasi Karyawan Baru dengan link
                          dibawah ini:
                        </p>
                      </div>

                      {/* ✅ SECTION: Penjelasan OKB */}
                      <div className="row">
                        <div className="col-12">
                          <div className="card border-primary">
                            <div className="card-header bg-primary text-white">
                              <h4 className="card-title mb-0 text-white">
                                📋 Petunjuk Training Orientasi Karyawan Baru
                                (OKB)
                              </h4>
                            </div>
                            <div className="card-body">
                              {/* ✅ Penjelasan Umum - Warna Warning */}
                              <div className="alert alert-warning border-warning mt-2">
                                <h5 className="text-dark">
                                  Informasi Penting:
                                </h5>
                                <p className="mb-2 text-dark">
                                  Training Orientasi Karyawan Baru (OKB) akan
                                  dilaksanakan via online (bisa diakses mulai
                                  dari sekarang). Mohon untuk isi{" "}
                                  <strong>topik 0 pretest</strong>
                                  (untuk mengetahui kemampuan kalian sebelum
                                  belajar, tidak perlu khawatir menjawab salah),
                                  kemudian pahami semua materi di{" "}
                                  <strong>topik 1-9</strong> (materi berupa
                                  video, pastikan sinyal internet mendukung
                                  karena tidak boleh ada 1 materipun yang
                                  dilewati, lalu kerjakan{" "}
                                  <strong>topik 9 post test</strong> dengan
                                  nilai minimum{" "}
                                  <span className="badge badge-danger">30</span>
                                  , tolong kerjakan dengan sungguh-sungguh)
                                </p>
                              </div>

                              {/* ✅ Instruksi Akses */}
                              <div className="mb-2">
                                <h5 className="text-primary">
                                  Cara Mengakses:
                                </h5>
                                <p>
                                  Silahkan akses Google Classroom dengan link di
                                  bawah halaman.
                                </p>
                              </div>

                              {/* ✅ Urutan Topik */}
                              <h5 className="text-primary">
                                Urutan Topik yang Harus Diikuti (Topik 0-9):
                              </h5>
                              <p className="text-danger font-weight-bold">
                                ⚠️ Silakan ikuti semua topik mulai topik 0-9
                                secara berurutan (mulai dari paling atas ke
                                bawah):
                              </p>

                              {/* ✅ PERBAIKI: List group dengan inline styles */}
                              <div className="list-group">
                                {/* ✅ Protokol Kesehatan - Warna Danger */}
                                <div
                                  className="list-group-item"
                                  style={{
                                    ...listGroupItemStyle,
                                    ...borderDangerStyle,
                                  }}
                                >
                                  <div className="d-flex w-100 justify-content-between">
                                    <h6 className="mb-1 text-danger">
                                      Wajib Membaca Protokol Kesehatan
                                    </h6>
                                    <small
                                      className="badge badge-danger"
                                      style={badgeStyle}
                                    >
                                      WAJIB BACA
                                    </small>
                                  </div>
                                  <p className="mb-1">
                                    Sebelum anda mengakses topik topik lainnya,
                                    mohon info ke Tim Recruitment apabila ada
                                    hal yang ingin ditanyakan / sampaikan
                                  </p>
                                </div>

                                {/* ✅ Pre Test - Warna Primary */}
                                <div
                                  className="list-group-item"
                                  style={{
                                    ...listGroupItemStyle,
                                    ...borderPrimaryStyle,
                                  }}
                                >
                                  <div className="d-flex w-100 justify-content-between">
                                    <h6 className="mb-1 text-primary">
                                      Topik 0 - Pre Test
                                    </h6>
                                    <small
                                      className="badge badge-primary"
                                      style={badgeStyle}
                                    >
                                      Mulai dari sini
                                    </small>
                                  </div>
                                  <p className="mb-1">
                                    Dikerjakan sebelum mengikuti topik 1-9,
                                    kerjakan semampu kalian walaupun belum
                                    menonton video
                                  </p>
                                </div>

                                {/* ✅ Topik 1-8 - Warna Default dengan border konsisten */}
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 1 - Value WINGS
                                  </h6>
                                </div>
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 2 - Food Safety Management System
                                  </h6>
                                </div>
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 3 - Personal Hygiene & Peraturan Zona
                                  </h6>
                                </div>
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 4 - SMK3L
                                  </h6>
                                </div>
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 5 - Perjanjian Kerja Bersama
                                  </h6>
                                </div>
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 6 - Highlight Pengelolaan Pekerja /
                                    Kepersonaliaan
                                  </h6>
                                </div>
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 7 - BPJS Ketenagakerjaan & BPJS
                                    Kesehatan
                                  </h6>
                                </div>
                                <div
                                  className="list-group-item"
                                  style={listGroupItemStyle}
                                >
                                  <h6 className="mb-1 text-dark">
                                    Topik 8 - 5R
                                  </h6>
                                </div>

                                {/* ✅ Post Test - Warna Primary dengan border */}
                                <div
                                  className="list-group-item"
                                  style={{
                                    ...listGroupItemStyle,
                                    ...borderPrimaryStyle,
                                  }}
                                >
                                  <div className="d-flex w-100 justify-content-between">
                                    <h6 className="mb-1 text-primary">
                                      ✅ Topik 9 - Post Test
                                    </h6>
                                    <small
                                      className="badge badge-warning"
                                      style={badgeStyle}
                                    >
                                      Nilai Min: 30
                                    </small>
                                  </div>
                                  <p className="mb-1">
                                    Dikerjakan apabila sudah selesai mengikuti
                                    topik 1-8, nilai <strong>minimum 30</strong>
                                  </p>
                                </div>
                              </div>

                              {/* ✅ Peringatan Penting - Warna Danger */}
                              <div className="alert alert-light border-danger mt-4">
                                <h5 className="text-danger">
                                  ⚠️ PERINGATAN PENTING:
                                </h5>
                                <p className="mb-0 text-dark">
                                  Mohon ikuti dan tonton semua materi dengan
                                  fokus dan
                                  <strong>
                                    {" "}
                                    KERJAKAN BERURUTAN DARI PRE TEST HINGGA POST
                                    TEST-NYA
                                  </strong>
                                  , karena hal ini berkaitan dengan{" "}
                                  <strong>keselamatan kerja kalian.</strong>
                                </p>
                              </div>

                              {/* ✅ Tombol Akses Ulang - Warna Primary */}
                              <div className="text-center mt-4">
                                <div className="d-flex justify-content-center mb-2">
                                  Silahkan klik tombol dibawah ini untuk
                                  mengakses Google Classroom:
                                </div>
                                <a
                                  href="https://classroom.google.com/c/NTc1MTkxMzgyMjVa?cjc=d6usetd"
                                  target="_blank"
                                  rel="noopener noreferrer"
                                  className="btn btn-primary btn-lg pulse-scale"
                                >
                                  🚀 Mulai Training OKB Sekarang
                                </a>
                              </div>
                              <div className="text-center mt-2">
                                <p className="text-uppercase text-dark">
                                  <strong>
                                    Jika sudah selesai OKB, maka silahkan
                                    menunggu informasi selanjutnya dari tim
                                    recruitment
                                  </strong>
                                </p>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  }
}

export default Form3;
